import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=29d8ba56&scoped=true&lang=html"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d8ba56",
  null
  
)

export default component.exports